/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

import {
  calcTextLifetime,
  calcWarningLifetime,
} from '@scripts/utils/string-utils';

type ToastStateType = {
  message: string;
  warning: string;
  timerId: number | null;
};

const initialState = (): ToastStateType => ({
  message: '',
  warning: '',
  timerId: null,
});

export const useToastStore = defineStore({
  id: 'toast',
  state: initialState,
  actions: {
    $reset() {
      clearTimeout(this.timerId ? this.timerId : undefined);
      Object.assign(this, initialState());
    },
    notify(message: string): void {
      this.message = message;
      this.warning = '';
      clearTimeout(this.timerId ? this.timerId : undefined);

      this.timerId = setTimeout(() => {
        this.message = '';
      }, calcTextLifetime({ text: message }));
    },
    warn(message: string): void {
      this.message = '';
      this.warning = message;
      clearTimeout(this.timerId ? this.timerId : undefined);

      this.timerId = setTimeout(() => {
        this.warning = '';
      }, calcWarningLifetime({ text: message }));
    },
  },
});
